export const SEASON_QUERY_PARAM = 'season'
export const EPISODE_QUERY_PARAM = 'episode'
